const PERMISSIONS_ORDER_PAGE = {
  VIEW: 'kiosk_order::get',
  NOTE_GET: 'kiosk_order_note::get',
  NOTE_CREATE: 'kiosk_order_note::create',
} as const;

export default PERMISSIONS_ORDER_PAGE;
